import Vue from "vue";
import Vuex from "vuex";
import VuexPersist from "vuex-persist";

import { HTTP } from "@/services/http";
import { flayers, adView, invoice } from "./api";

Vue.use(Vuex);

const vuexLocalStorage = new VuexPersist({
  key: "vuex", // The key to store the state on in the storage provider.
  storage: window.localStorage, // or window.sessionStorage or localForage
  // Function that passes the state and returns the state with only the objects you want to store.
  // reducer: state => state,
  // Function that passes a mutation and lets you decide if it should update the state in localStorage.
  // filter: mutation => (true)
});

export const store = new Vuex.Store({
  plugins: [vuexLocalStorage.plugin],
  state: {
    currentUser: {},
    withdrawals: [],
    authToken: null,
    isLoading: false,
  },
  mutations: {
    setCurrentUser(state, user) {
      state.currentUser = user;
    },
    setWithdrawals(state, items) {
      state.withdrawals = items;
    },
    setAuthToken(state, token) {
      state.authToken = token;
    },
    setLoading(state, isLoading) {
      state.isLoading = isLoading;
    },
  },
  getters: {
    currentUser: (state) => state.currentUser,
    withdrawals: (state) => state.withdrawals,
    authToken: (state) => state.authToken,
    isLoading: (state) => state.isLoading,
  },
  actions: {
    getWithdrawals(context) {
      HTTP({
        method: "get",
        url: "/api/v1/client/withdrawals?per_page=1000",
        headers: {
          "content-type": "application/json",
          Authorization: store.getters.authToken,
        },
      })
        .then((response) => {
          context.commit("setWithdrawals", response.data);
        })
        .catch((error) => {
          error.response.data &&
            error.response.data.errors.map((m) => {
              this.$toasted.show(m, {
                position: "top-right",
                duration: 5000,
                type: "error",
                closeOnSwipe: true,
              });
            });
        });
    },
    async getUser({ commit, state, dispatch }) {
      commit("setLoading", true);
      try {
        let response = await HTTP({
          url: "/api/v1/client/users/1",
          method: "get",
          headers: {
            "content-type": "application/json",
            Authorization: store.getters.authToken,
          },
        });
        commit("setCurrentUser", response.data);
        dispatch("adView/initPendingTasks");
        commit("setLoading", false);
      } catch (error) {
        commit("setLoading", false);
        throw error;
      }
      return state.postsList;
    },
  },
  modules: {
    flayers,
    adView,
    invoice,
  },
});
